import shaka from 'shaka-player'

let el
let container
let video
let btn
let shortVideo
let shortPauseBtn

let isShortPaused
let player

const manifestUrl = '/video/showcase-manifest-full.mpd'
const iosplaylist = '/video/dest/all.m3u8'

let tries = 0
const maxTries = 5
let codes

export function Showcase() {
    el = document.querySelector('.js-showcase')

    if (!el) {
        return
    }

    container = el.querySelector('.js-showcase-video-container')
    video = el.querySelector('.js-showcase-video')
    btn = el.querySelector('.js-showcase-btn')
    shortVideo = el.querySelector('.js-showcase-short-video')
    shortPauseBtn = el.querySelector('.js-showcase-short-pause-toggle')

    btn.addEventListener('click', open)

    window.addEventListener('keyup', (evt) => {
        if (evt.key === 'Escape') {
            close()
        }
    })

    el.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('js-showcase-close')) {
            close()
        }
    })

    shortPauseBtn.addEventListener('click', () => {
        if (shortVideo.paused) {
            shortVideo.play()
            shortPauseBtn.classList.remove('is-paused')
            isShortPaused = false
        } else {
            shortVideo.pause()
            isShortPaused = true
            shortPauseBtn.classList.add('is-paused')
        }
    })
}

function open() {
    container.classList.add('is-active')
    shortVideo.pause()
    initPlayer()
}

function close() {
    container.classList.remove('is-active')
    if (!isShortPaused) {
        shortVideo.play()
    }
    video.pause()
}

async function initPlayer() {
    if (iOS()) {
        video.src = iosplaylist

        return
    }

    shaka.polyfill.installAll()

    if (!shaka.Player.isBrowserSupported()) {
        video.src = iosplaylist
        return
    }

    player = new shaka.Player(video)
    player.addEventListener('error', onErrorEvent)

    try {
        await player.load(manifestUrl)
        video.play()
        // player.play()
        // This runs if the asynchronous load is successful.
        console.log('The video has now been loaded!')
    } catch (e) {
        video.src = iosplaylist
        // onError is executed if the asynchronous load fails.

        onError(e)

        if (tries >= maxTries) {
            return
        }

        player.addEventListener('error', onErrorEvent)
        player.destroy()
        tries++
        initPlayer()
    }
}

function onErrorEvent(event) {
    // Extract the shaka.util.Error object from the event.
    onError(event.detail)
}

function onError(error) {
    // Log the error.
    console.error('Error code', error.code, 'object', error)
    if (!codes) {
        codes = Object.keys(shaka.util.Error.Code).reduce((acc, el) => {
            acc.push([el, shaka.util.Error.Code[el]])
            return acc
        }, [])
    }

    const errorMsg = codes.filter((el) => el[1] === error.code)

    window.codes = codes
    console.error(errorMsg)
    console.log(shaka.util)
}

function iOS() {
    return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
            navigator.platform
        ) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    )
}
